import { render, staticRenderFns } from "./DropdownAccount.vue?vue&type=template&id=64c088d0&"
import script from "./DropdownAccount.vue?vue&type=script&lang=js&"
export * from "./DropdownAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports